import { PlinkoBet } from 'views/InhouseGame/Plinko/types/Bet'
import { particleColor } from '../../../config'
import PlinkoGraphicBase from './Base'

export interface ParticleConstructor {
  x: number
  y: number
  size: number
  bet: PlinkoBet
}

class Particle extends PlinkoGraphicBase {
  x: number
  y: number
  size: number
  bet: PlinkoBet

  constructor(Matter: any, paramater: ParticleConstructor) {
    const { x, y, size, bet } = paramater
    const options = {
      restitution: 0.6,
      collisionFilter: {
        group: -1,
      },
    }

    const body = Matter.Bodies.circle(x, y, size, options)
    super(Matter, body)

    this.x = x
    this.y = y
    this.bet = bet
    this.size = size
  }

  display(p5: any) {
    const pos = this.body.position
    const angle = this.body.angle
    const color = particleColor[this.bet.risk]

    p5.push()
    p5.translate(pos.x, pos.y)
    p5.rotate(angle)
    p5.noStroke()

    p5.fill(color.r1, color.g1, color.b1)
    p5.ellipseMode(p5.RADIUS)
    p5.ellipse(0, 0, this.size, this.size)

    p5.fill(color.r2, color.g2, color.b2)
    p5.ellipseMode(p5.RADIUS)
    p5.ellipse(0, 0, (this.size / 3) * 2, (this.size / 3) * 2)

    p5.fill(color.r1, color.g1, color.b1)
    p5.ellipseMode(p5.RADIUS)
    p5.ellipse(0, 0, (this.size / 3) * 2 - 1.5, (this.size / 3) * 2 - 1.5)
    p5.pop()
  }
}

export default Particle
